import { Grid, Stack } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';

import { useOrderQuery } from 'api/hooks/leihbar';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { ProductCard } from '../Products/ProductCard';
import { OrderDetailHeader } from '../components/OrderDetailHeader';
import { ProductCardFooter } from './components/ProductCardFooter';

export const OrderDetailOverview = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { data: order, isLoading } = useOrderQuery(parseInt(id!));

  usePageHeading(
    {
      heading:
        order && !isLoading
          ? t(translations.pages.leihbar.orders.heading(), { customerName: order.name })
          : t(translations.common.loading()),
      headingProps: { back: location.state?.back ?? `/leihbar` }
    },
    [order, isLoading]
  );

  if (!order) {
    return null;
  }

  return (
    <Stack marginTop={2} gap={3}>
      <OrderDetailHeader order={order} />
      <Grid container>
        {order.bookings?.map(booking => {
          if (!booking.article?.product) {
            return null;
          }
          return (
            <Grid item xs={12} md={6} lg={4} key={booking.id}>
              <ProductCard
                className={`${location.state?.selectedBooking === booking.id ? 'pulsate' : ''} ${
                  booking.deletedAt !== null && 'card-canceled'
                }`}
                product={booking.article.product}
                footer={<ProductCardFooter booking={booking} />}
                canceled={booking.deletedAt !== null}
              />
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};
